(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jonelia-blitz"] && !Shopify.designMode) return;
  try {
    
(function(){
 function init(root){
  if(root.dataset.blitzReady)return;root.dataset.blitzReady='1';
  var slots=Array.from(root.querySelectorAll('[data-blitz-slot]'));
  slots.forEach(function(slot){
   var time=slot.querySelector('[data-checked]');
   if(time&&time.dateTime){var d=new Date(time.dateTime);if(!isNaN(d))time.textContent=d.toLocaleString(document.documentElement.lang||'de-AT',{timeZone:'Europe/Vienna',day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit'})+' (Wien)';}
   var form=slot.querySelector('[data-blitz-form]');
   if(form)form.addEventListener('submit',async function(e){
    e.preventDefault();var button=form.querySelector('button'),status=form.querySelector('[data-blitz-status]'),now=Date.now()/1000;
    if(now<Number(slot.dataset.start)||now>=Number(slot.dataset.end)||Number(slot.dataset.used)>=30){status.textContent=slot.dataset.expired;button.disabled=true;return;}
    var idInput=form.elements.namedItem('id'),quantityInput=form.elements.namedItem('quantity'),returnInput=form.elements.namedItem('return_to');
    if(idInput)idInput.value=slot.dataset.variant;
    if(quantityInput)quantityInput.value='1';
    if(returnInput)returnInput.value=slot.dataset.discount;
    button.disabled=true;status.textContent='';
    try{var response=await fetch(slot.dataset.add,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
     if(!response.ok)throw new Error('add');
     window.location.assign(slot.dataset.discount);
    }catch(error){status.textContent=slot.dataset.error;button.disabled=false;}
   });
  });
  function tick(){
   var now=Date.now()/1000,shown=false;
   slots.forEach(function(slot){
    var active=!shown&&now>=Number(slot.dataset.start)&&now<Number(slot.dataset.end);
    slot.hidden=!active;
    if(active){shown=true;
     var h=slot.querySelector('[data-hours]'),m=slot.querySelector('[data-minutes]'),s=slot.querySelector('[data-seconds]');
     if(h&&m&&s){var left=Math.max(0,Math.floor(Number(slot.dataset.end)-now));h.textContent=String(Math.floor(left/3600)).padStart(2,'0');m.textContent=String(Math.floor(left%3600/60)).padStart(2,'0');s.textContent=String(left%60).padStart(2,'0');}
    }
   });
   root.hidden=!shown;
  }
  tick();var timer=setInterval(function(){if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 document.querySelectorAll('[data-blitz-root]').forEach(init);
 document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('[data-blitz-root]').forEach(init);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jonelia-blitzaktion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jonelia-flash')) {
  customElements.define('jonelia-flash', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const finish = Date.parse(this.dataset.end);
        if (!Number.isFinite(finish) || Date.now() >= finish) {
          this.closest('.jon-flash-section').hidden = true;
          clearInterval(this.timer);
        }
      };
      this.update();
      this.timer = setInterval(this.update, 15000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jonelia-brands"] && !Shopify.designMode) return;
  try {
    
function initialiseJoneliaBrands(scope){scope.querySelectorAll('.jon-marken__az:not([data-ready])').forEach(root=>{root.dataset.ready='true';const input=root.querySelector('[data-brand-search]');const items=[...root.querySelectorAll('[data-brand-name]')];const empty=root.querySelector('[data-brand-empty]');input.addEventListener('input',()=>{const q=input.value.trim().toLocaleLowerCase('de');let shown=0;items.forEach(a=>{const match=a.dataset.brandName.includes(q);a.hidden=!match;if(match)shown++});empty.hidden=shown>0;});});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialiseJoneliaBrands(document));else initialiseJoneliaBrands(document);document.addEventListener('shopify:section:load',event=>initialiseJoneliaBrands(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jonelia-campaigns"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jonelia-campaigns')) {
  customElements.define('jonelia-campaigns', class extends HTMLElement {
    connectedCallback() {
      this.blocks = Array.from(this.querySelectorAll('[data-jon-campaign]'));
      this.started = performance.now();
      this.server = Number(this.dataset.serverTime) * 1000;
      this.update = () => {
        const now = this.server + performance.now() - this.started;
        let selected = null;
        if (this.dataset.enabled === 'true' && Number.isFinite(now)) {
          for (const block of this.blocks) {
            const start = Date.parse(block.dataset.start), end = Date.parse(block.dataset.end);
            const percent = Number(block.dataset.percent);
            const hasZones = /(?:Z|[+-]\d{2}:\d{2})$/.test(block.dataset.start) && /(?:Z|[+-]\d{2}:\d{2})$/.test(block.dataset.end);
            if (hasZones && Number.isFinite(start) && Number.isFinite(end) && end > start && percent >= 10 && percent <= 19 && Number.isInteger(percent) && now >= start && now < end) { selected = block; break; }
          }
        }
        for (const block of this.blocks) block.hidden = block !== selected;
        this.hidden = !selected;
      };
      this.update();
      this.timer = setInterval(this.update, 15000);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jonelia-marken-az"] && !Shopify.designMode) return;
  try {
    
function initJoneliaMarkenAz(scope){
  scope.querySelectorAll('.jon-azm:not([data-ready])').forEach(function(root){
    root.dataset.ready='true';
    var input=root.querySelector('[data-jonazm-search]');
    if(!input)return;
    var items=[].slice.call(root.querySelectorAll('[data-jonazm-name]'));
    var empty=root.querySelector('[data-jonazm-empty]');
    input.addEventListener('input',function(){
      var q=input.value.trim().toLocaleLowerCase('de');
      var shown=0;
      items.forEach(function(a){
        var match=a.dataset.jonazmName.indexOf(q)!==-1;
        a.hidden=!match;
        if(match)shown++;
      });
      if(empty)empty.hidden=shown>0;
    });
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initJoneliaMarkenAz(document);});}else{initJoneliaMarkenAz(document);}
document.addEventListener('shopify:section:load',function(event){initJoneliaMarkenAz(event.target);});

  } catch(e) { console.error(e); }
})();
})();
